import React, { Component, Fragment } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import StockOpnameHeader from "../components/stockOpnameHeader";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ReportSO from "../components/reportSO";
import KelebihanSO from "../components/kelebihanSO";
import KekuranganSO from "../components/kekuranganSO";
import {
  constructListTanpaQR,
  constructSubmitResolvingNonQRRequest,
  constructSubmitResolvingRequest,
  fetchKekuranganSO,
  fetchKelebihanSO,
  fetchReportSO,
} from "../service";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { HttpStatus } from "../../../common/Constants";

class StockOpnameResolve extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      reportSO: {
        listDataQR: [],
        listDataTanpaQR: [],
      },
      dataKelebihan: {
        listDataQR: "",
        listDataTanpaQR: [],
        edit: false,
        errorsTanpaQR: {},
      },
      dataKekurangan: {
        listDataQR: [],
        listDataTanpaQR: [],
        totalDibebankanKaryawanQR: 0,
        totalDibebankanPerusahaanQR: 0,
        totalQR: 0,
        totalDibebankanKaryawanTanpaQR: 0,
        totalDibebankanPerusahaanTanpaQR: 0,
        totalTanpaQR: 0,
        grandTotal: 0,
        userResolveStockOpname: {}
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await fetchReportSO(
      this.setState.bind(this),
      this.props.controls.stockOpnameType.value,
      contructQueryParam({
        stockOpnameNo: this.props.controls.noStockOpname.value,
      })
    );
    await fetchKelebihanSO(
      this.setState.bind(this),
      this.props.controls.stockOpnameType.value,
      contructQueryParam({
        nomorStockOpname: this.props.controls.noStockOpname.value,
      })
    );
    await fetchKekuranganSO(
      this.setState.bind(this),
      this.props.controls.stockOpnameType.value,
      contructQueryParam({
        stockOpnameNo: this.props.controls.noStockOpname.value,
      })
    );
    this.handleTriggerLoading();
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.dataKekurangan.listDataQR !==
      this.state.dataKekurangan.listDataQR
    ) {
      this.setState((prevValue) => {
        const totalDibebankanKaryawanQR =
          this.state.dataKekurangan.listDataQR?.reduce(
            (total, item) => total + (item.nilaiDibebankanKaryawan || 0),
            0
          );

        const totalDibebankanPerusahaanQR =
          this.state.dataKekurangan.listDataQR?.reduce(
            (total, item) => total + (item.nilaiDibebankanPerusahaan || 0),
            0
          );

        const totalQR = totalDibebankanKaryawanQR + totalDibebankanPerusahaanQR;
        const grandTotal = totalQR + prevValue.dataKekurangan.totalTanpaQR;

        if (
          totalDibebankanKaryawanQR !==
            prevState.dataKekurangan.totalDibebankanKaryawanQR ||
          totalDibebankanPerusahaanQR !==
            prevState.dataKekurangan.totalDibebankanPerusahaanQR ||
          totalQR !== prevState.dataKekurangan.totalQR
        ) {
          return {
            ...prevValue,
            dataKekurangan: {
              ...prevValue.dataKekurangan,
              totalDibebankanKaryawanQR,
              totalDibebankanPerusahaanQR,
              totalQR,
              grandTotal,
            },
          };
        }
        return null;
      });
    }

    if (
      prevState.dataKekurangan.listDataTanpaQR !==
      this.state.dataKekurangan.listDataTanpaQR
    ) {
      this.setState((prevValue) => {
        const totalDibebankanKaryawanTanpaQR =
          this.state.dataKekurangan.listDataTanpaQR.reduce(
            (total, item) => total + (item.nilaiDibebankanKaryawan || 0),
            0
          );

        const totalDibebankanPerusahaanTanpaQR =
          this.state.dataKekurangan.listDataTanpaQR.reduce(
            (total, item) => total + (item.nilaiDibebankanPerusahaan || 0),
            0
          );

        const totalTanpaQR =
          totalDibebankanKaryawanTanpaQR + totalDibebankanPerusahaanTanpaQR;

        const grandTotal = prevValue.dataKekurangan.totalQR + totalTanpaQR;

        if (
          totalDibebankanKaryawanTanpaQR !==
            prevState.dataKekurangan.totalDibebankanKaryawanTanpaQR ||
          totalDibebankanPerusahaanTanpaQR !==
            prevState.dataKekurangan.totalDibebankanPerusahaanTanpaQR ||
          totalTanpaQR !== prevState.dataKekurangan.totalTanpaQR
        ) {
          return {
            ...prevValue,
            dataKekurangan: {
              ...prevValue.dataKekurangan,
              totalDibebankanKaryawanTanpaQR,
              totalDibebankanPerusahaanTanpaQR,
              totalTanpaQR,
              grandTotal,
            },
          };
        }
        return null;
      });
    }
  }

  handleSubmitKelebihan = async () => {
    const listDataTanpaQR = constructListTanpaQR(
      this.state.dataKelebihan.listDataTanpaQR,
      this.props.controls.stockOpnameType.value.value,
      this.props.idUser
    );
    console.log(listDataTanpaQR);

    let errors = {};
    listDataTanpaQR.forEach((row, index) => {
      let rowErrors = {};
      console.log(row);

      if (!row.code || row.code.trim() === "") {
        rowErrors.code = "Nama wajib diisi";
      }

      if (row.id === null) {
        if (
          row.diffQty === null ||
          row.diffQty === "" ||
          isNaN(Number(row.diffQty)) ||
          Number(row.diffQty) === 0
        ) {
          rowErrors.diffQty = "Diff Qty wajib diisi";
        }
      }

      // if (!row.notes || row.notes.trim() === "") {
      //   rowErrors.notes = "Keterangan wajib diisi";
      // }

      if (Object.keys(rowErrors).length > 0) {
        errors[index] = rowErrors;
      }
    });

    if (Object.keys(errors).length > 0) {
      this.setState((prev) => ({
        ...prev,
        dataKelebihan: {
          ...prev.dataKelebihan,
          errorsTanpaQR: errors,
        },
      }));
      return;
    }

    this.setState((prev) => ({
      ...prev,
      dataKelebihan: {
        ...prev.dataKelebihan,
        errorsTanpaQR: {},
      },
    }));

    const request = {
      nomorStockOpname: this.props.controls.noStockOpname.value,
      listDataQR: this.state.dataKelebihan.listDataQR,
      listDataTanpaQR,
      stockOpnameType:
        this.props.controls.stockOpnameType.value.value === "GIFT"
          ? "HADIAH"
          : this.props.controls.stockOpnameType.value.value === "OTHER_ITEM"
          ? "BARANG LAIN"
          : this.props.controls.stockOpnameType.value.value,
    };
    console.log(request);

    if (!this.state.dataKelebihan.edit) this.submitKelebihan(request);
    this.setState((prevValue) => ({
      ...prevValue,
      dataKelebihan: {
        ...prevValue.dataKelebihan,
        edit: !prevValue.dataKelebihan.edit,
      },
    }));
  };

  submitKelebihan = async (request) => {
    console.log(request);

    this.handleTriggerLoading();
    
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").saveKelebihanSO,
      menuName: "Resolve Stock Opname",
      setError: this.props.setError,
      args: request,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataKelebihan: {
          ...prev.dataKelebihan,
          listDataTanpaQR: prev.dataKelebihan.listDataTanpaQR.map((x) => ({
            ...x,
            isSaved: true,
          })),
        },
      }));
    }

    this.handleTriggerLoading();
  };

  // adjust when develop/add feature for gift other and part
  handleSubmitResolve = async () => {
    const request = {
      noStockOpname: this.props.controls.noStockOpname.value,
      stockOpnameType: this.props.controls.stockOpnameType.value.value == 'OTHER_ITEM' ? 'OTHERS' : this.props.controls.stockOpnameType.value.value,
      resolvingNote: this.state.dataKelebihan.listDataQR,
      listDetail: constructSubmitResolvingRequest(
        this.state.dataKekurangan?.listDataQR,
        this.props.controls.stockOpnameType.value.value
      ),
      listDetailNonQrCode: constructSubmitResolvingNonQRRequest(
        this.state.dataKekurangan?.listDataTanpaQR,
        this.props.controls.stockOpnameType.value.value
      ),
    };
    console.log(request);

    this.handleTriggerLoading();
    await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").submitResolving,
      menuName: "Resolve Stock Opname",
      setError: this.props.setError,
      args: request,
    });
    this.props.onRefresh();
    this.handleTriggerLoading();
  };

  handleSetState = (callback) => {
    this.setState(callback);
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  render() {
    return (
      <>
        <Fragment>
          <SimpleModal
            title="Report Stock Opname"
            visible={this.props.visible}
            onClickClose={() => this.props.onClickClose()}
            content={
              <ModalContainer>
                <FlexView column marginBottom={20}>
                  <StockOpnameHeader {...this.props} />
                </FlexView>

                <Tabs>
                  <TabList>
                    <Tab id="report">Report SO</Tab>
                    <Tab id="kelebihan">Kelebihan</Tab>
                    <Tab id="kekurangan">Kekurangan</Tab>
                  </TabList>
                  <TabPanel>
                    <ReportSO
                      state={this.state}
                      handleLoading={this.handleTriggerLoading}
                      {...this.props}
                    />
                  </TabPanel>
                  <TabPanel>
                    <KelebihanSO
                      state={this.state}
                      handleSetState={this.handleSetState}
                      handleSubmitKelebihan={this.handleSubmitKelebihan}
                      {...this.props}
                    />
                  </TabPanel>
                  <TabPanel>
                    <KekuranganSO
                      state={this.state}
                      handleSetState={this.handleSetState}
                      handleSubmitResolve={this.handleSubmitResolve}
                      {...this.props}
                    />
                  </TabPanel>
                </Tabs>
              </ModalContainer>
            }
          />
        </Fragment>

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

export default withFormGroup(StockOpnameResolve);
